import { BetManager, Bus, SiteConfigManager } from '@atlas/core';

// Prematch event click handler
export const eventClickHandler = payload => {
  if (payload.outcomeId && payload.event) {
    BetManager.selectBet(payload);
  }
};

export const getFlyingBetslipConfig = () => {
  const state = {
    hasExtended: false,
    hasNewNavigation: false,
    hasSimple: false,
  };

  const isShowMobileNavigation = window.IS_IFRAME
    ? SiteConfigManager.getConfig('config.config.sportsbook.newBottomNavigationFrameMobile')
    : SiteConfigManager.getConfig('config.config.general.newMobileNavigation');

  if (!isShowMobileNavigation) {
    return state;
  }

  state.hasNewNavigation = true;

  if (SiteConfigManager.getConfig('config.config.betslip.enableExtendedFlyingBetslip')) {
    return {
      ...state,
      hasExtended: true,
    };
  }

  if (!window.IS_IFRAME || SiteConfigManager.getConfig('config.config.betslip.flyingBetslip')) {
    return {
      ...state,
      hasSimple: true,
    };
  }

  return state;
};

export const sportsbookRouterListenerCb = state => Bus.emit(Bus.events.sport.urlState, state);
